import classNames from 'classnames';
import * as React from 'react';
import { PaymentCycle } from 'enums';
import { RootStore, withInjectedRootStore } from 'providers';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { AdvancedPlansFeature } from 'types';
import s from '../Cycles/Cycles.scss';
import { DisclaimerFooter } from './DisclaimerFooter';
import { DiscalimerHeading } from './DisclaimerHeading';
import { MissingFeaturesList } from './MissingFeatures';

interface MonthlyDisclaimerProps {
  missingFeatureList: AdvancedPlansFeature[];
  rootStore: RootStore;
}

const MonthlyDisclaimerComp: React.FC<MonthlyDisclaimerProps> = ({
  missingFeatureList,
  rootStore,
}) => {
  const { setCurrentCycle, isEligibleForRevShare } = rootStore.appStore;
  const { theme } = usePageModeContext();

  return missingFeatureList ? (
    <div
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        e.preventDefault();
        setCurrentCycle({ cycle: PaymentCycle.YEARLY });
      }}
      data-hook='advanced-plans-monthly-diclaimer'
      className={classNames(s.monthlyDisclaimer, theme)}
    >
      <DiscalimerHeading isEligibleForRevShare={isEligibleForRevShare} />
      <MissingFeaturesList missingFeatures={missingFeatureList} />
      <DisclaimerFooter />
    </div>
  ) : null;
};

export const MonthlyDisclaimer = withInjectedRootStore(MonthlyDisclaimerComp);
